export default __webpack_public_path__ + "static/media/13.f4d201f0.pdf";